import {
    Address,
    Classification,
    DeliveryDateType,
    DocumentStatus,
    FunctionalAsset,
    GenericObject,
    Media,
    OrderType,
    ReceiptAlert,
    copyFields,
    fixDates,
} from '@synergy/models';

import { Contact } from '../../../common/models/contact';
import { Customer } from '../../../common/models/customer';
import { PaymentTerm } from '../../../common/models/payment-term';
import { PurchaseOrderGenericItem } from './purchase-order-generic-item';
import { PurchaseOrderProductItem } from './purchase-order-product-item';
import { Supplier } from '../../../common/models/supplier';
import { User } from '../../../common/models/user';

export class PurchaseOrder {
    public id!: number;
    public number!: string;
    public orderReference!: string;
    public salesOrderNumber!: string;
    public salesOrderId!: number;
    public orderDate!: Date;
    public customerOrderNumber!: string;
    public sendPurchaseOrder!: boolean;
    public title!: string;
    public costCentre!: string;
    public commission!: string;
    public internalNote!: string;
    public type!: OrderType;
    public status!: DocumentStatus;
    public netShippingCosts!: number;
    public netSurcharge!: number;
    public responsibleContact!: Contact;
    public customerAccount!: Customer;
    public customerContact!: Contact;
    public customerAvisoContact!: Contact;
    public supplierAccount!: Supplier;
    public supplierContact!: Contact;
    public noteToSupplier!: string;
    public currency!: string;
    public isTaxFree!: boolean;
    public termsOfDeliveryContent!: string;
    public paymentTerm!: PaymentTerm;
    public supplierBonus!: string;
    public deliveryDate?: Date;
    public deliveryDateType?: DeliveryDateType;
    public totalPrice!: number;
    public totalNetPrice!: number;
    public deliveryAddress!: Address;
    public invoiceAddress?: Address;
    public chargingInvoiceAddress?: Address;
    public purchaseOrderItems!: PurchaseOrderProductItem[];
    public surchargeItems: PurchaseOrderGenericItem[] = [];
    public createdAt!: Date;
    public updatedAt?: Date;
    public createdBy!: User;
    public updatedBy?: User;
    public media!: Media[];
    public receiptAlert?: ReceiptAlert;
    public classifications?: Classification[];
    public functionalAssetId!: number;
    public functionalAsset!: FunctionalAsset | null;
    public requireFunctionalAssets!: boolean;
    public supplierOfferNumber!: string;

    public static fromPlainObject(object: GenericObject): PurchaseOrder {
        const order = new PurchaseOrder();

        copyFields(object, order);

        if (object['responsibleContact']) {
            order.responsibleContact = Contact.fromPlainObject(object['responsibleContact']);
        }

        if (object['customerAccount']) {
            order.customerAccount = Customer.fromPlainObject(object['customerAccount']);
        }

        if (object['customerContact']) {
            order.customerContact = Contact.fromPlainObject(object['customerContact']);
        }

        if (object['customerAvisoContact']) {
            order.customerAvisoContact = Contact.fromPlainObject(object['customerAvisoContact']);
        }

        if (object['supplierAccount']) {
            order.supplierAccount = Supplier.fromPlainObject(object['supplierAccount']);
        }

        if (object['supplierContact']) {
            order.supplierContact = Contact.fromPlainObject(object['supplierContact']);
        }

        if (object['deliveryAddress']) {
            order.deliveryAddress = Address.fromPlainObject(object['deliveryAddress']);
        }

        if (object['invoiceAddress']) {
            order.invoiceAddress = Address.fromPlainObject(object['invoiceAddress']);
        }

        if (object['purchaseOrderItems']) {
            order.purchaseOrderItems = object['purchaseOrderItems'].map(PurchaseOrderProductItem.fromPlainObject);
        }

        if (object['media']) {
            order.media = object['media'].map(Media.fromPlainObject);
        }
        if (object['functionalAsset']) {
            order.functionalAssetId = object['functionalAsset'].id;
        }

        fixDates(order, ['orderDate', 'desiredDeliveryDate', 'createdAt', 'updatedAt']);

        return order;
    }
}
